// Library methods
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { forwardRef, useMemo } from "react";
import { Link } from "react-router-dom";

// MUI Components
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

// Utilities
import packageJson from "../../../../package.json";
import useClinic from "../../../hooks/useClinic";
import { ADMIN_TIMEZONE } from "../../../enums";

const Footer = forwardRef((_props, ref) => {
  // internationalization
  const { t } = useTranslation();
  const { clinicTimezone } = useClinic();

  const isAdmin = useMemo(
    () => window?.location?.pathname?.includes("admin"),
    []
  );

  const timezoneToUse = useMemo(
    () => (isAdmin ? ADMIN_TIMEZONE : clinicTimezone),
    [isAdmin, clinicTimezone]
  );

  return (
    <Box
      id="footer-container"
      className="w-full bg-baseDark text-white"
      ref={ref}
    >
      <Container
        maxWidth="xl"
        sx={{
          "& .MuiContainer-root": {
            marginLeft: 0,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column-reverse", sm: "row" },
            alignItems: { xs: "center", sm: "flex-end" },
            justifyContent: "space-between",
            my: 2,
          }}
        >
          <Link
            to="https://docsend.com/view/sbk6xanvbkkc737q"
            target="_blank"
            style={{ fontWeight: "bold", color: "#E2772E" }}
          >
            {t("Privacy Policy")}
          </Link>
          <Box sx={{ textAlign: { xs: "center", sm: "right" } }}>
            <Typography variant="subtitle1">
              {`v${packageJson.version || "3.0"}`}
            </Typography>
            <Typography variant="subtitle1">
              {`©${DateTime.now().setZone(timezoneToUse).year} Retinalogik Inc. ${t("all_rights_reserved")}`}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
});

export default Footer;
